import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { CloseButton } from 'components/common/Toast';
import { useAppContext } from 'providers/AppProvider';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { enUS } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('en', enUS);
setDefaultLocale('en');
import 'react-toastify/dist/ReactToastify.css';
import ua from './utils/detectUserAgent';

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition },
  } = useAppContext();

  useEffect(() => {
    if (ua.windows()) document.documentElement.classList.add('windows');
    if (ua.chrome()) document.documentElement.classList.add('chrome');
    if (ua.firefox()) document.documentElement.classList.add('firefox');
    if (ua.safari()) document.documentElement.classList.add('safari');
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_ENV !== 'development') return;

    document.title = 'WMS (DEV)';

    const canvas = document.createElement('canvas');
    canvas.width = 32;
    canvas.height = 32;
    const ctx = canvas.getContext('2d');

    const img = new Image();
    img.onload = () => {
      ctx.drawImage(img, 0, 0, 32, 32);
      ctx.fillStyle = '#e63757';
      ctx.fillRect(0, 20, 32, 12);
      ctx.fillStyle = '#ffffff';
      ctx.font = 'bold 9px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('DEV', 16, 26);

      let link = document.querySelector("link[rel*='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'shortcut icon';
        document.head.appendChild(link);
      }
      link.href = canvas.toDataURL();
    };
    img.src = '/favicon.ico';
  }, []);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition, HTMLClassList]);

  return (
    <>
      <Outlet />
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position="bottom-left"
      />
    </>
  );
};

export default App;
